<template>
    <!--Footer-->
    <div class="flex justify-end pt-2">
        <slot></slot>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>